import type React from "react";
import type { pageLayoutProps } from "./types.props";
import styles from "./PageLayout.module.css";

const PageLayout: React.FC<pageLayoutProps> = ({
    header,
    main,
    footer,
    sidebar,
}) => {
    return (
        <div className={styles.container}>
            <div className={`${styles.wrapper} ${sidebar ? styles.withSidebar : ""}`}>
                {header && <header>{header}</header>}
                {sidebar && <aside className={styles.sidebar}>{sidebar}</aside>}
                <main>{main}</main>
                {footer && <footer>{footer}</footer>}
            </div>
        </div>
    );
};

export default PageLayout;
